/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.patients.di

import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import studio.oddpods.cauce.feature.patients.AddPatientMode
import studio.oddpods.cauce.feature.patients.AddPatientWithSessionViewModel
import studio.oddpods.cauce.feature.patients.PatientDetailViewModel
import studio.oddpods.cauce.feature.patients.PatientEditViewModel
import studio.oddpods.cauce.feature.patients.PatientListViewModel

val PatientsModule = module {
    viewModelOf(::PatientListViewModel)
    viewModel { params ->
        AddPatientWithSessionViewModel(
            mode = params.get<AddPatientMode>(),
            patientRepository = get(),
            sessionRepository = get(),
            recurringScheduleRepository = get(),
            profileRepository = get(),
            analyticsHelper = get(),
            currencyFormatter = get(),
            dateFormatter = get(),
        )
    }
    viewModel { params ->
        PatientDetailViewModel(
            patientId = params.get(),
            patientRepository = get(),
            sessionRepository = get(),
            userDataRepository = get(),
            currencyFormatter = get(),
            dateFormatter = get(),
            reminderRepository = get(),
            paymentRepository = get(),
            recurringScheduleRepository = get(),
        )
    }
    viewModel { params ->
        PatientEditViewModel(
            patientId = params.get(),
            patientRepository = get(),
            currencyFormatter = get(),
        )
    }
}
